import React from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav style={navStyle}>
      <div style={{ fontWeight: 700 }}>Oslolabs</div>
      <div>
        <Link to="/" style={linkStyle}>Home</Link>
        <Link to="/about" style={linkStyle}>About</Link>
        <Link to="/blog" style={linkStyle}>Blogs</Link>
        <Link to="/contact" style={linkStyle}>Contact us</Link>
      </div>
      <div>
        <Link to="/contact" style={contactButton}>Contact</Link>
      </div>
    </nav>
  );
}


const navStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 20px",
  borderBottom: "1px solid #eee",
};

const linkStyle = {
  marginLeft: 14,
  textDecoration: "none",
  color:"#000"
};
const contactButton = {
  textDecoration: "none",
  color:"#000",
  padding: 10,
  borderRadius:10,
  borderColor:"#000",
  borderWidth:1
};